import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Label, Table } from 'react-bootstrap';
import geolib from 'geolib';
import unitConverter from 'convert-units';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { isEmpty } from 'lodash';
import Badge from 'components/v2/Badge';
import { withLocaleContext } from 'providers/locale-settings-context';
class DriverList extends React.Component {
    getNearbyDrivers() {
        const nearbyDrivers = this.props.nearbyDrivers.map((driver) => {
            const offerCoords = this.props.shipment.origin[0].coords;
            const driverCoords = driver.coords;
            driver.name = driver.first_name + ' ' + driver.last_name;
            driver.hasOffer = '';
            driver.distance = geolib
                .getDistance({ latitude: offerCoords[1], longitude: offerCoords[0] }, { latitude: driverCoords[1], longitude: driverCoords[0] })
                .toFixed(2);
            return driver;
        });
        // Sort the drivers based on distance from the offer
        return nearbyDrivers.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));
    }
    renderNearbyDrivers() {
        const { t, carrierPreferences, localeData } = this.props;
        const nearbyDrivers = this.getNearbyDrivers().map((driver, i) => {
            const { carrier: { _id: carrierId }, } = driver;
            let preferenceBadge = '';
            if (!isEmpty(carrierPreferences)) {
                if (carrierPreferences.preferred.includes(carrierId)) {
                    preferenceBadge = (React.createElement(Badge, { dataTestId: `Badge-85d63ad0-${i}`, rounded: true, color: "green", className: "label" }, t('PREFERRED')));
                }
                else if (carrierPreferences.excluded.includes(carrierId)) {
                    preferenceBadge = (React.createElement(Badge, { dataTestId: `Badge-b160a5a3-${i}`, rounded: true, color: "red", className: "label" }, t('EXCLUDED')));
                }
            }
            const equipment = driver.equipment_class
                ? titleize(t(driver.equipment_class.label))
                : titleize(t('UNKNOWN'));
            return ((React.createElement("tr", { "data-testid": `tr-fed3262e-${i}`, key: i },
                React.createElement("td", { "data-testid": `td-4b40b0c1-${i}` },
                    React.createElement("div", { "data-testid": `div-4a6c4b86-${i}`, style: { marginTop: 4 } },
                        React.createElement(Label, { bsSize: "xsmall", bsStyle: "success" }, driver.hasOffer))),
                React.createElement("td", { "data-testid": `td-3a16904f-${i}` },
                    React.createElement("div", { "data-testid": `div-bf06f64a-${i}`, style: { marginTop: 4 } },
                        React.createElement(Label, { bsSize: "xsmall", bsStyle: "info" }, equipment))),
                React.createElement("td", { "data-testid": `td-a93d72db-${i}` },
                    React.createElement(Link, { to: `/users/${driver._id}` }, driver.name)),
                React.createElement("td", { "data-testid": `td-62e9fe27-${i}` },
                    React.createElement(Link, { to: `/users/${driver.carrier._id}` }, driver.carrier.name)),
                !isEmpty(carrierPreferences) && React.createElement("td", { "data-testid": `td-e7caef40-${i}` }, preferenceBadge),
                React.createElement("td", { "data-testid": `td-51e70be1-${i}` }, driver.phone),
                React.createElement("td", { "data-testid": `td-422bdf7f-${i}` },
                    unitConverter(driver.distance)
                        .from('m')
                        .to(localeData.distance_units)
                        .toFixed(2),
                    ' ',
                    localeData.distance_units),
                React.createElement("td", { "data-testid": `td-0a6e18b4-${i}` },
                    React.createElement(Button, { bsStyle: "primary", bsSize: "small", onClick: () => this.props.onAssignDriver(driver) }, t('ASSIGN'))))));
        });
        return nearbyDrivers;
    }
    render() {
        const nearbyDrivers = this.renderNearbyDrivers();
        const { t, carrierPreferences } = this.props;
        return ((React.createElement(Table, { striped: true, condensed: true, hover: true, fill: true },
            React.createElement("thead", { "data-testid": "thead-1cf99dda" },
                React.createElement("tr", { "data-testid": "tr-0468fa2f" },
                    React.createElement("td", { "data-testid": "td-39bf88c8" }),
                    React.createElement("td", { "data-testid": "td-a3f79d8d" },
                        React.createElement("strong", { "data-testid": "strong-c3127019" }, titleize(t('VEHICLE')))),
                    React.createElement("td", { "data-testid": "td-1f82a85f" },
                        React.createElement("strong", { "data-testid": "strong-5963d9f3" }, titleize(t('DRIVER')))),
                    React.createElement("td", { "data-testid": "td-624e3ea0" },
                        React.createElement("strong", { "data-testid": "strong-ec4ebd10" }, titleize(t('CARRIER')))),
                    !isEmpty(carrierPreferences) && (React.createElement("td", { "data-testid": "td-fd9f8baf" },
                        React.createElement("strong", { "data-testid": "strong-7a988b6e" }, titleize(t('PREFERENCE'))))),
                    React.createElement("td", { "data-testid": "td-30f46676" },
                        React.createElement("strong", { "data-testid": "strong-b5c66235" }, titleize(t('PHONE')))),
                    React.createElement("td", { "data-testid": "td-1e5ab3bf" },
                        React.createElement("strong", { "data-testid": "strong-ad4b08ba" }, titleize(t('DISTANCE')))),
                    React.createElement("td", { "data-testid": "td-f6a88552" }))),
            React.createElement("tbody", { "data-testid": "tbody-e9e5c844" }, nearbyDrivers))));
    }
}
export default withTranslation()(withLocaleContext(DriverList));
